<template>
  <div class="rank-custom-wrapper">
    <RankFidelisationFilters :default="filters" @update="handleFilters" />

    <div class="card card-inverse card-info text-center" v-if="loading">
      <div class="card-block">
        <blockquote class="card-blockquote">Chargement en cours ...</blockquote>
      </div>
    </div>
    <div class="card text-center" v-else-if="data.length === 0">
      <div class="card-block">
        <blockquote class="card-blockquote">
          Aucune données, appliquer ou modifier les filtres
        </blockquote>
      </div>
    </div>

    <div v-else>
      <Tabs v-model="activeTab">
        <Tab header="Carte">
          <RankFidelisationResume :data="mapData" :filters="filters" />
        </Tab>
        <Tab header="Classement">
          <RankFidelisationDetails :data="data" :filters="filters" />
        </Tab>
      </Tabs>
    </div>
  </div>
</template>

<script>
import RankFidelisationFilters from "@/components/coach-manager/fidelisation/RankFidelisationFilters";
import RankFidelisationResume from "@/components/coach-manager/fidelisation/RankFidelisationResume";
import RankFidelisationDetails from "@/components/coach-manager/fidelisation/RankFidelisationDetails";
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";
import { mapGetters } from "vuex";

export default {
  components: {
    RankFidelisationFilters,
    RankFidelisationResume,
    RankFidelisationDetails,
    Tabs,
    Tab,
  },
  data() {
    return {
      loading: false,
      data: [],
      activeTab: 0,
      filters: this.defaultFilters(),
    };
  },

  computed: {
    ...mapGetters({
      departments: "getDepartments",
    }),

    zipcodes() {
      return this.departments.map(({ code, name }) => {
        if (code === "all") {
          return { label: name, value: code };
        } else {
          return { label: code + " - " + name, value: code };
        }
      });
    },

    mapData() {
      const domTom = ["971", "972", "973", "974", "976"];
      const departments = [...this.zipcodes].filter(
        (dpt) => !domTom.includes(dpt.value) && dpt.value !== "all",
      );

      departments.forEach((dpt) => {
        dpt.data = this.departmentCoachInfo(dpt.value);
      });

      return departments;
    },
  },

  methods: {
    handleFilters(newFilters) {
      this.filters = newFilters;

      this.loadCoachs();
    },

    async loadCoachs() {
      try {
        this.loading = true;

        const { data } = await this.$api.get(`/rank/fidelisations`, {
          params: {
            departments:
              this.filters.departments &&
              this.filters.departments.map((dpt) => dpt.value),
          },
        });

        this.data = data;
      } catch (e) {
        this.$errorToast("Impossible de charger les données");
      } finally {
        this.loading = false;
      }
    },

    departmentCoachInfo(dpt) {
      let departmentCoachs = this.data.filter((coach) => {
        if (coach.department && typeof coach.department === "string") {
          return coach.department.slice(0, 2) === dpt;
        }
      });

      return departmentCoachs;
    },

    defaultFilters() {
      return {
        department: null,
      };
    },
  },
};
</script>
